const THROW_ERROR = false;

export const assertNoUndefinedProperties = (obj) => {
    for (const [key, value] of Object.entries(obj)) {
        if (value === undefined) {
            const message = `${key} is undefined`;
            if (THROW_ERROR) {
                throw new Error(message);
            }
            console.error(message);
        }
    }
};
